export const TAB_NAME = 'Tab name'
export const REQUIREMENT_COUNT = 'Requirement count'
export const OPENED_FROM = 'Opened from'
export const APPLICATION_TYPE = 'Application type'
export const SCHOLARSHIP_ID = 'Scholarship ID'
export const IS_RECOMMENDED = 'Recommended'
export const REQUIREMENT_TYPE = 'Requirement type'
export const CONFIDENCE_SCORE = 'Confidence score value'
export const APPLICATION_COUNT = 'Applicant count'
export const SCHOLARSHIP_EXPIRATION_DATE = 'Deadline'
export const SCHOLARSHIP_AMOUNT = 'Amount'
export const IS_SEEN = 'New'
export const CLICKED_FROM = 'Clicked from'
export const SELECTED_CATEGORIES = 'category selected'
export const SCHOLARSHIP_CATEGORY = 'Scholarship category'
export const ENTERED_VALUE = 'Value entered'
export const SCHOLARSHIP_POINTS = 'Scholarship points'
export const TOTAL_USER_POINTS = 'Total user points'
export const PAYOUT_METHOD = 'Payout method'
export const AWARD_COUNT = 'Award count'
export const DERIVED_STATUS = 'Current Status'
export const IS_OPTIONAL = 'Optional'
export const GOAL_SET = 'Goal set'
export const CATEGORY_SELECTED = 'category selected'
export const SORT_BY = 'sortBy'
export const ACCOUNT_ID = 'Account ID'
export const SCHOLARSHIP_TYPE = 'Scholarship Type'
export const IS_SIMILAR = 'Similar scholarship'
export const MAINTENANCE_MODE = 'Maintenance mode'
export const IS_EASY = 'Is easy'

// default props
export const ACCOUNT = 'account'
export const IS_MEMBER = 'member'
export const AFF_ID = 'affid'
export const FSET = 'fset'
export const IS_MOBILE = 'isMobile'
export const SRV = 'SRV'
export const COUNTRY = 'country'
export const URL = 'url'

// user info update
export const SAVED_SCHOLARSHIP_COUNT = 'Picked scholarships count'
export const STARTED_SCHOLARSHIP_COUNT = 'Started applications count'
export const IGNORED_SCHOLARSHIP_COUNT = 'Ignored scholarships count'
export const CAP_FSET = 'Fset'
export const LEVEL_NAME = 'Level name'
export const APPLICATION_SUBMITTED_COUNT = 'Applications submitted count'
export const PACKAGE = 'Package'
export const PACKAGE_ID = 'Package ID'
export const PACKAGE_NAME = 'Package name'
export const ELIGIBLE_SCHOLARSHIP_COUNT = 'Eligible scholarships count'
export const TRANSACTION_COUNT = 'Transactions count'

// payment modal
export const PAYMENT_PACKAGE_ID = 'id'
export const PAYMENT_PACKAGE_NAME = 'name'
export const PAYMENT_PACKAGE_PRICE = 'price'

// no engagement modal
export const NO_ENGAGEMENT_REASON = 'No engagement reason'
export const NO_ENGAGEMENT_REASON_TEXT = 'No engagement reason text'

export const FREEMIUM_LIMITED = 'Freemium limited'

export const FREEMIUM_LOCKED_SCREEN = 'Freemium locked screen'
export const MEMBERSHIP_NAME = 'Membership name'
export const IS_BLURRED = 'Blurred scholarship'
export const PRO_MODAL_NEW = 'Pro modal new'
export const FREEMIUM_CREDIBILITY = 'Freemium credibility'
export const CREDIBILITY_SCORE = 'Credibility score'
export const FREEMIUM_STATUSES = 'Freemium statuses'
export const SIMILAR_CARD = 'Similar card'
export const ACTIVATION_MODAL = 'Activation modal'
export const FREEMIUM_EXIT_POPUP = 'Freemium exit popup'
export const SCHOLARSHIP_NUMBER = 'Scholarship number'
export const VIDEO_RECORDER = 'Video recorder'
export const SCHOLARSHIP_PROVIDER_NAME = 'Scholarship provider name'
export const SOCIAL_NETWORK_NAME = 'Social network name'
export const PROFILE_UPDATE_CONTEXT = 'Profile update context'
export const MEMBERSHIP_STATUS = 'Membership status'
export const WINNERS_BUTTON_LOCATION = 'Winners button location'
export const DISPLAYED_ELIGIBILITIES = 'Displayed Eligibilities'
export const ELIGIBILITIES_SECTION_VISIBLE = 'Eligibilities Section Is Visible'
export const NEWS_TICKER_VISIBLE = 'Dashboard news ticker is visible'
export const WINNER_BLAST_WINNER = 'Winner blast winner ID'
export const WINNER_BLAST_VIDEO = 'Winner blast has video'
export const WINNER_BLAST_VIDEO_CURRENT_TIME = 'Winner blast video current time'
export const WINNER_BLAST_REACTION = 'Winner blast reaction'
export const PREVIOUS_WINNERS_WINNER = 'Previous winner ID'
export const PREVIOUS_WINNERS_VIDEO = 'Previous winner has video'
export const PREVIOUS_WINNERS_VIDEO_CURRENT_TIME = 'Previous winner video current time'
export const DISPLAYED_PREVIOUS_WINNERS = 'Displayed Previous Winners'
export const LOADED_PREVIOUS_WINNERS = 'Loaded Previous Winners'
export const PREVIOUS_WINNERS_SECTION_VISIBLE = 'Previous Winners Section Is Visible'
export const SCHOLARSHIP_PROVIDER_STATISTICS = 'Scholarship Provider Statistics'
export const SCHOLARSHIP_PROVIDER_IS_VISIBLE = 'Scholarship Provider Section Is Visible'
export const HEALTH_BAR_FEATURE_FLAG = 'Health Bar Feature Flag'
export const LOOP_GUEST_ACCOUNT = 'Loop Guest Account Feature Flag'
export const LOOP_TRIAL_EXTENSION = 'Loop Trial Extension Feature Flag'
